type VideoTypesType = {
    url: 'url',
    youtube: 'youtube',
    vimeo: 'vimeo',
}
export const VideoTypes: VideoTypesType = {
    url: 'url',
    youtube: 'youtube',
    vimeo: 'vimeo',
}

export type VideoTypesValues = typeof VideoTypes[keyof typeof VideoTypes]

export const AllVideoTypes: VideoTypesValues[] = Array.from(Object.values(VideoTypes));

export default VideoTypes;